// ===== VIDEO TESTIMONIAL SECTION JAVASCRIPT =====

document.addEventListener('DOMContentLoaded', function() {
  duplicateSlidesForDesktop();
  initVideoTestimonialSlider();
  initVideoPlayControls();
  if ('IntersectionObserver' in window) initIntersectionObserver();
  preloadVideos();
  handleVideoErrors();
});

// Duplicate slides if fewer than needed for desktop
function duplicateSlidesForDesktop() {
  const swiperContainers = document.querySelectorAll('.product_video_testimonials_unique_swiper');
  swiperContainers.forEach(container => {
    const slides = container.querySelectorAll('.swiper-slide');
    const minSlides = 4; // desktop requirement
    if (slides.length < minSlides) {
      const wrapper = container.querySelector('.swiper-wrapper');
      const cloneCount = minSlides - slides.length;
      for (let i = 0; i < cloneCount; i++) {
        const clone = slides[i % slides.length].cloneNode(true);
        clone.classList.add('slide-duplicate');
        wrapper.appendChild(clone);
      }
    }
  });
}

// Initialize Swiper Slider
function initVideoTestimonialSlider() {
  const swiperContainers = document.querySelectorAll('.product_video_testimonials_unique_swiper');

  swiperContainers.forEach(container => {
    const disableDesktop = container.getAttribute('data-disable-desktop-scroll') === 'true';

    const swiper = new Swiper(container, {
      slidesPerView: 'auto',   // 👈 use CSS width
      spaceBetween: 30,        // 👈 gap between slides
      loop: true,
      slidesPerGroup: 1,       // one card per navigation click
      centeredSlides: false,
      autoplay: false,

      breakpoints: {
        // Mobile/tablet behave normally
        320: { slidesPerView: 'auto', spaceBetween: 15 },
  480: { slidesPerView: 'auto', spaceBetween: 20 },
  640: { slidesPerView: 'auto', spaceBetween: 25 },
        768: { slidesPerView: 2, spaceBetween: 30, slidesPerGroup: 1 },
        1024: disableDesktop
          ? {
              slidesPerView: 4,
              spaceBetween: 30,
              allowTouchMove: false,  // 👈 no dragging
              allowSlideNext: false,  // 👈 disable next btn
              allowSlidePrev: false   // 👈 disable prev btn
            }
          : {
              slidesPerView: 3,
              spaceBetween: 30
            },
        1200: disableDesktop
          ? {
              slidesPerView: 4,
              spaceBetween: 30,
              allowTouchMove: false,
              allowSlideNext: false,
              allowSlidePrev: false
            }
          : {
              slidesPerView: 4,
              spaceBetween: 30
            }
      },

      navigation: {
        nextEl: container.querySelector('.swiper-button-next'),
        prevEl: container.querySelector('.swiper-button-prev'),
      },

      pagination: {
        el: container.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
        dynamicMainBullets: 5,
      },

      effect: 'slide',
      speed: 600,

      on: {
        init: function() {
          container.classList.add('swiper-loaded');
          pauseAllVideos(container);
          this.slideToLoop(0, 0);
        },
        slideChange: function() {
          pauseAllVideos(container);
        }
      }
    });

    // If disabled on desktop → visually dim buttons
    if (disableDesktop && window.innerWidth >= 1024) {
      const prevBtn = container.querySelector('.swiper-button-prev');
      const nextBtn = container.querySelector('.swiper-button-next');
      if (prevBtn) prevBtn.classList.add('swiper-button-disabled');
      if (nextBtn) nextBtn.classList.add('swiper-button-disabled');
    }

    container.swiperInstance = swiper;
  });
}

// === Video Play Controls ===
function initVideoPlayControls() {
  const videoContainers = document.querySelectorAll('.mp4_play_video_new');
  videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const playButton = container.querySelector('.play_video_new');
    const muteButton = container.querySelector('.video_mute_button_new');

    if (video) {
      video.muted = true;
      updateMuteButtonIcon(video, muteButton);

      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;
      video.controls = false;

      if (playButton) {
        playButton.addEventListener('click', e => {
          e.preventDefault();
          toggleVideoPlay(container, video);
        });
      }

      video.addEventListener('click', e => {
        e.preventDefault();
        toggleVideoPlay(container, video);
      });

      if (muteButton) {
        muteButton.addEventListener('click', e => {
          e.preventDefault();
          toggleVideoMute(video, muteButton);
        });
      }

      video.addEventListener('play', () => {
        container.classList.add('playing');
        if (playButton) playButton.style.opacity = '0';
      });

      video.addEventListener('pause', () => {
        container.classList.remove('playing');
        if (playButton) playButton.style.opacity = '1';
      });

      video.addEventListener('ended', () => {
        container.classList.remove('playing');
        if (playButton) playButton.style.opacity = '1';
        video.currentTime = 0;
      });
    }
  });
}

// === Video Helpers ===
function toggleVideoPlay(container, video) {
  if (video.paused) {
    pauseAllVideos();
    video.play().catch(err => console.log('Video play failed:', err));
    container.classList.add('playing');
  } else {
    video.pause();
    container.classList.remove('playing');
  }
}

function toggleVideoMute(video, muteButton) {
  video.muted = !video.muted;
  updateMuteButtonIcon(video, muteButton);
}

function updateMuteButtonIcon(video, muteButton) {
  if (!muteButton) return;
  muteButton.innerHTML = video.muted
    ? `<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>`
    : `<svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>`;
}

function pauseAllVideos(exceptContainer = null) {
  const allVideoContainers = document.querySelectorAll('.mp4_play_video_new');
  allVideoContainers.forEach(container => {
    if (exceptContainer && container.closest('.swiper') === exceptContainer) return;
    const video = container.querySelector('video');
    if (video && !video.paused) {
      video.pause();
      container.classList.remove('playing');
    }
  });
}

// === Observers & Utilities ===
function initIntersectionObserver() {
  const observerOptions = { threshold: 0.1, rootMargin: '50px' };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) pauseAllVideos(entry.target);
    });
  }, observerOptions);

  const sections = document.querySelectorAll('.product_video_testimonials_main_new');
  sections.forEach(section => observer.observe(section));
}

let resizeTimeout;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function() {
    const swipers = document.querySelectorAll('.product_video_testimonials_unique_swiper');
    swipers.forEach(container => {
      if (container.swiperInstance) {
        container.swiperInstance.update();
        if (window.innerWidth < 640) container.swiperInstance.slideTo(0, 0);
      }
    });
  }, 250);
});

document.addEventListener('visibilitychange', function() {
  if (document.hidden) pauseAllVideos();
});

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}
document.body.classList.add(isTouchDevice() ? 'touch-device' : 'no-touch');

function preloadVideos() {
  const videos = document.querySelectorAll('.product_video_testimonials_unique_swiper video');
  videos.forEach(video => {
    video.preload = 'metadata';
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
  });
}

function handleVideoErrors() {
  const videos = document.querySelectorAll('.product_video_testimonials_unique_swiper video');
  videos.forEach(video => {
    video.addEventListener('error', function() {
      console.warn('Video failed to load:', video.src);
      const container = video.closest('.mp4_play_video_new');
      if (container) container.style.display = 'none';
    });
  });
}
